import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';

import ButtonBlock from 'financing/components/Utils/ButtonBlock.jsx';

import 'financing/components/JointInfosForm/JointInfosForm.scss';

class JointInfosForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            coApplicantOptions: [
                {
                    key: 0,
                    isSelected: props.hasCoApplicant,
                    label: LocaleService.t('FINANCING.JOINT_INFOS.YES'),
                    option: true,
                },
                {
                    key: 1,
                    isSelected: !props.hasCoApplicant,
                    label: LocaleService.t('FINANCING.JOINT_INFOS.NO'),
                    option: false,
                },
            ],
            hasCoApplicant: props.hasCoApplicant,
            isValid: false,
        };

        this.onDone = this.onDone.bind(this);
        this.onCoApplicationOptionChange = this.onCoApplicationOptionChange.bind(this);
    }

    onCoApplicationOptionChange(newValue) {
        this.setState((oldState) => {
            const { coApplicantOptions } = oldState;
            return {
                hasCoApplicant: newValue,
                coApplicantOptions: coApplicantOptions.map((option) => {
                    option.isSelected = newValue === option.option;
                    return option;
                }),
            };
        });
    }

    onDone() {
        this.setState({
            isValid: true,
        });
        this.props.onDone(this.state.hasCoApplicant);
    }

    render() {
        const { isOpen } = this.props;
        const { isValid } = this.state;

        const buttons = this.state.coApplicantOptions.map((coApplicantOption) => {
            const isChecked = coApplicantOption.isSelected;
            return (
                <div className="radio-button-cta-wrapper--single" key={coApplicantOption.key}>
                    <input
                        type="radio"
                        id={coApplicantOption.key}
                        name="genderOption"
                        value="coApplicant"
                        onChange={() => this.onCoApplicationOptionChange(coApplicantOption.option)}
                        checked={isChecked}
                    />
                    <label htmlFor={coApplicantOption.key}>{coApplicantOption.label}</label>
                </div>
            );
        });

        const coApplicantForm = (
            <div>
                <div className="radio-button-cta-wrapper">{buttons}</div>
                <ButtonBlock onBack={this.props.onBack} onDone={this.onDone} />
            </div>
        );

        const formClass = isOpen
            ? 'financingBlockForm coApplicantForm is-open'
            : `financingBlockForm coApplicantForm is-closed ${isValid ? 'is-valid' : ''}`;

        return (
            <div className={formClass}>
                <icon className="icon-Crochet is-util" />
                <h3 className="sr-text is-bold is-util">
                    {LocaleService.t('FINANCING.JOINT_INFOS.JOINT_APPLICATION')}
                </h3>
                {isOpen && coApplicantForm}
            </div>
        );
    }
}

JointInfosForm.defaultProps = {
    isOpen: true,
};

JointInfosForm.propTypes = {
    hasCoApplicant: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool,
    onBack: PropTypes.func.isRequired,
    onDone: PropTypes.func.isRequired,
};

JointInfosForm.displayName = 'JointInfosForm';

export default JointInfosForm;
